<template>
    <rkm-layout-body title="Lista de procedimento">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({ name: 'parametrizacao-procedimento-create' })"
                color="primary"
                authorize="store-parametrizacao-procedimento"
            >
                Configurar procedimento
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
import List from '@/components/parametrizacao/procedimento/List'

export default {
    components: { List },
}
</script>